module.exports = __webpack_public_path__ + "static/media/no-data-group.364661e6.svg";